var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8405_11537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2454",
    d: "M23.9805 23.9805V0.0195312H0.0195312V23.9805H23.9805Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0390625
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8405_11537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2460",
    d: "M21.4678 6.52055C21.4562 5.91056 21.4452 5.33428 21.4452 4.77684C21.4452 4.34006 21.0912 3.98601 20.6543 3.98601C17.2723 3.98601 14.6973 3.01397 12.5509 0.927045C12.2438 0.628405 11.7552 0.628545 11.4483 0.927045C9.3021 3.01397 6.72754 3.98601 3.3457 3.98601C2.90892 3.98601 2.55482 4.34006 2.55482 4.77684C2.55482 5.33442 2.5439 5.91089 2.53218 6.52102C2.42381 12.1977 2.27535 19.9723 11.7405 23.2532C11.8245 23.2823 11.912 23.2969 11.9995 23.2969C12.087 23.2969 12.1747 23.2823 12.2585 23.2532C21.7244 19.9722 21.5762 12.1974 21.4678 6.52055Z",
    stroke: "#0C66E4",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2464",
    d: "M13.4016 10.3628V7.39694H10.5954V10.3628H7.62939V13.169H10.5954V16.1348H13.4016V13.169H16.3672V10.3628H13.4016Z",
    stroke: "#0C66E4",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsIcon);
export default __webpack_public_path__ + "static/media/fsIcon.08c141ff9dfb2f705540502a633fda3f.svg";
export { ForwardRef as ReactComponent };